export default __webpack_public_path__ + "static/media/logo--medium.c8f9e910.svg";